import React from 'react';
import PropTypes from 'prop-types';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import './materialSelectField.scss';
import { primaryBlue, textColorGray } from 'theme/mainColors';

class MaterialSelectField extends React.PureComponent {
  state = {
    touched: false
  };

  handleChange = (ev, key, value) => {
    this.setState({ touched: true });
    this.props.profilesActions.updateProfileField(value);
    this.props.onSelect(value);
  };

  render() {
    const { label, required, value, pristineForm, options } = this.props;
    return (
      <SelectField
        className="material-select-field"
        floatingLabelText={ label }
        underlineStyle={ { borderColor: textColorGray} }
        underlineFocusStyle={ { borderColor: primaryBlue } }
        floatingLabelStyle={ { color: textColorGray } }
        errorText={ required && !value && this.state.touched && !pristineForm && 'This field is required' }
        onChange={ this.handleChange }
        value={ value }
        autoWidth
      >
        { options.map(option => <MenuItem primaryText={ option.name } value={ option.id } key={ option.id } />) }
      </SelectField>
    );
  }
}

MaterialSelectField.propTypes = {
  label: PropTypes.string.isRequired,
  required: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
  options: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
    name: PropTypes.string
  })).isRequired,
  pristineForm: PropTypes.bool.isRequired,
  onSelect: PropTypes.func,
  profilesActions: PropTypes.shape({
    updateProfileField: PropTypes.func
  }).isRequired
};

MaterialSelectField.defaultProps = {
  required: false,
  onSelect: () => null
};

export default MaterialSelectField;



// WEBPACK FOOTER //
// ./src/shared/components/connectedTextField/c/materialSelectField/MaterialSelectField.js